/**
 * V2 onboarding design tokens — non-component exports.
 * Separated from primitives.tsx so Fast Refresh works cleanly.
 */

// ── Brand colors ──────────────────────────────────────────────────────────────
export const V2C = {
  brand:       '#5956F6',
  brandDark:   '#3D3AF0',
  brandSoft:   '#E3E3FD',
  brandSofter: '#EFEFFE',
  bg:          '#F8F8FF',
  bgAlt:       '#F1F1FE',
  ink:         '#0B0B1F',
  inkSoft:     '#1E1E33',
  mute:        '#6B6A8A',
  muteSoft:    '#9B9AB7',
  line:        'rgba(89,86,246,0.10)',
  lineHard:    'rgba(89,86,246,0.18)',
  accent:      '#FF9A6C',
  ok:          '#15803d',
  okBg:        '#DCFCE7',
  okSoft:      '#86EFAC',
  warn:        '#B45309',
  warnBg:      '#FEF3C7',
  warnSoft:    '#FDE68A',
  err:         '#B42318',
  errBg:       '#FEE4E2',
  errSoft:     '#FECDCA',
};

// ── Typography ────────────────────────────────────────────────────────────────
export const fontBody    = '"Satoshi", "Inter", -apple-system, system-ui, sans-serif';
export const fontDisplay = '"Bricolage Grotesque", "Satoshi", -apple-system, system-ui, sans-serif';
export const fontMono    = '"JetBrains Mono", ui-monospace, monospace';
